import React, { Component } from "react";
import { connect } from "react-redux";

import UserWidget from "../../UI/UserWidget";
import * as matchesAction from "../../../_actions/matchesActions";
import getMemberProfileById from "../../../_selectors/matchesSelectors/getMemberProfileById";

class UserWidgetContainer extends Component {
  componentDidMount() {
    const { user, getProfileById } = this.props;
    getProfileById(user);
  }
  render() {
    const {
      profile,
      actionButton,
      cancel,
      onAccept,
      onReject,
      onCancel
    } = this.props;

    return (
      <UserWidget
        user={profile}
        actionButton={actionButton}
        onAccept={() => {
          onAccept(profile);
        }}
        onReject={() => {
          onReject(profile);
        }}
        cancel={cancel}
        onCancel={() => {
          onCancel(profile);
        }}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  profile: getMemberProfileById(state, ownProps.user)
});

const mapDispatchToProps = dispatch => ({
  getProfileById: profileId =>
    dispatch(matchesAction.getMatchedMemberProfile(profileId))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserWidgetContainer);



// WEBPACK FOOTER //
// ./src/_components/Matches/UserWidgetContainer/index.js